export /**
 *
 * Side effect - Sends the user to the specified URL
 * @param {string} url
 */
const goToWebsite = (url) => {
  window.open(url);
};
